export default __webpack_public_path__ + "static/media/ic-image.14c59b7c.svg";